/**
 * @file TitleComponent.tsx
 * @description
 * -----------------------------------------------------
 * Archivo que contiene el componente de título
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2025-01-15
 * @modified 2025-10-17
 * @author Correcta
 * @author Cristina Bosa
 * @author Sergio Manjón
 * @copyright © Correcta
 * @license Private
 * */

"use client";

import DynamicBackButtonComponent from "@/components/ui/DynamicBackButtonComponent";
import { TitleComponentProps } from "@/types/ui";
import MyBreadcrumbs from "@/components/nav/BreadCrumbs";

const TitleComponent = ({
  title,
  description,
  hasBack,
  path,
  backLabel,
}: TitleComponentProps) => {
  return (
    <header className="main__header">
      <MyBreadcrumbs />
      <h1>{title}</h1>
      {description && <h2>{description}</h2>}
      {hasBack && (
        <DynamicBackButtonComponent
          labelKey={backLabel ?? undefined}
          href={path ?? undefined}
        />
      )}
    </header>
  );
};

export default TitleComponent;
